
import { defineComponent } from 'vue';
import PortalHeader from '@/components/Layout/PortalHeader.vue';
import ActiveLoanSelector from '@/components/MultiLoan/ActiveLoanSelector.vue';

export default defineComponent({
  name: 'PortalLayout',

  components: { ActiveLoanSelector, PortalHeader },

  computed: {
    canSwitchLoans(): boolean {
      return this.$route.name === 'home' && this.$store.getters['User/availableLoans'].length > 1;
    }
  }
});
